import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import FaultCodesTable from '../../components/layout/FaultCodesTable';
import { apiFetch } from '../../api/apiClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartPulse } from '@fortawesome/free-solid-svg-icons';

const EMPTY_SECTIONS = [
  { id: 'inverter', title: 'Inverter Fault Codes', codes: [] },
  { id: 'dcdc-converter', title: 'DC-DC Converter Fault Codes', codes: [] },
  { id: 'bess', title: 'BESS Fault Codes', codes: [] },
];

function scrollToHash(hash) {
  const id = String(hash || '').replace(/^#/, '');
  if (!id) {
    return;
  }
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function FaultCodes() {
  const [sections, setSections] = useState(EMPTY_SECTIONS);
  const { hash } = useLocation();

  useEffect(() => {
    document.title = 'Vivosol Plant Performance Insights Hub | Help / Documentation / Fault Codes';
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const raw = await apiFetch('/api/fault-codes');
        const nextSections = Array.isArray(raw?.sections) ? raw.sections : EMPTY_SECTIONS;
        if (!cancelled) {
          setSections(nextSections);
        }
      } catch (apiError) {
        console.warn('API fetch failed for /api/fault-codes:', apiError);
        if (!cancelled) {
          setSections(EMPTY_SECTIONS);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => scrollToHash(hash), 150);
    return () => window.clearTimeout(timer);
  }, [hash, sections]);

  return (
    <SidebarPageLayout id="fault-codes">
      <div className="content p-5">
        <h1 className="mb-0">Fault Codes</h1>
        <Breadcrumbs />

        {sections.map((section) => (
          <div id={section.id} key={section.id} className="panel p-3 mb-5">
            <div className="header d-flex justify-content-between pb-3">
              <div className="left d-flex gap-3">
                <span>
                  <FontAwesomeIcon icon={faHeartPulse} /> {String(section.title || '').toUpperCase()}
                </span>
              </div>
            </div>
            <FaultCodesTable data={section.codes} />
          </div>
        ))}
      </div>
    </SidebarPageLayout>
  );
}

export default FaultCodes;
